// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/element-#232021/index.css
// module id = HwKU
// module chunks = 25